export const ClientLOADING = "client/Loading";
export const ClientERROR = "client/Error";
export const ClientListSUCCESS = "client/ListSuccess";
export const ClientCreateSUCCESS = "client/CreateSuccess";
export const ClientUpdateSUCCESS = "client/UpdateSuccess";
export const ClientDeleteSUCCESS = "client/DeleteSuccess";
